import { BrandUtils } from '@core/services/brand/brand.utils';

export const KEYCLOACK_CONFIG = {
	keycloak: BrandUtils.getKeycloakConfig(),
	portalBaseUrlSegmentRegex: /\/api\/.*management-ui/,
	useKeycloakService: true,
};
